/* eslint-disable import/prefer-default-export */
import { CurrencyCode } from 'types/payment';

export const CURRENCY_CODE_GBP: CurrencyCode = 'GBP';